import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import type { Candidate } from '@core/candidate-types';
import { IconComponent } from '@core/user-interface-legacy';

import { RevealButtonComponent } from '../reveal-button/reveal-button.component';

@Component({
  selector: 'rt-anonymous-candidate-empty-state',
  imports: [IconComponent, RevealButtonComponent],
  templateUrl: './anonymous-candidate-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './anonymous-candidate-empty-state.component.less',
})
export class AnonymousCandidateEmptyStateComponent {
  public message = input.required<string>();
  public candidate = input<Candidate>();
  public skipRevealConfirmation = input<boolean>(false);
  public canReveal = input<boolean>(false);

  public toggleDataVisibility = output<boolean>();
  public saveSkipRevealConfirmation = output();
}
